<script setup>
import {computed, onMounted, ref, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MemberMatchingCorpView from "./detail/MemberMatchingCorpView.vue";
import MemberMatchingApplyStateView from "./detail/MemberMatchingApplyStateView.vue";

const route = useRoute();
const router = useRouter();
const loaded = ref(false);
const tabRef = ref(null);

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const tabOptions = [
  { label: '채용제안 현황', value: 'matching-state' },
  { label: '입사지원 현황', value: 'matching-applyState' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.tab));

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;

  if (tabRef.value) {
    tabRef.value.init(tab.value);
  }

  if (selectedTabValue.value === tab.value) {
    return;
  }

  router.push({ query: { ...route.query, tab: tab.value } });
};

watch(
    () => route.query.tab,
    (tab) => {
      const nextTabValue = getTabValue(tab);
      selectedTabValue.value = nextTabValue;

      if(tabRef.value) {
        tabRef.value.init(nextTabValue);
      }
    },
    { immediate: true }
);
</script>

<template>
  <div>
    <div class="tab-wrap mb-sm">
      <KSATab
          ref="tabRef"
          :options="tabOptions"
          @change="onChangeTab"
          style="grid-template-columns: repeat(2, 1fr);"
      />
    </div>
    <div v-if="selectedTabValue === 'matching-state'">
      <MemberMatchingCorpView :user="user" />
    </div>
    <div v-else-if="selectedTabValue === 'matching-applyState'">
      <MemberMatchingApplyStateView :user="user" />
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
</style>
